import React from 'react'
import { NFTHistoryItemWrapper } from '../../../pages/Profile/History/styled'
import { IActivityDetail } from '../../Default/Activity/IActivityDetail'
import { NFTURLItems } from '../../../data/NFTURLItems'
import { NavLink } from 'react-router-dom'
import { getEtherscanLink } from '../../../../../utils'
import { ExternalLink, TYPE } from '../../../../../theme'
import { getWalletAddress } from '../../../utils/NFTFormatedData'
import { useGetNFTPrice, useGetSaleTokenItem } from '../../../../../hooks/useNFTMarketPlace'
import { YTS } from '../../../../../constants'
import { ChainId } from '@yetiswap/sdk'
import NFTPriceSymbol from '../../../components/NFTPriceSymbol'

import { ReactComponent as PriceTags } from '../../../../../assets/images/price-tags.svg'
import { ReactComponent as Removed } from '../../../../../assets/images/x.svg'
import YTSLogo from '../../../../../assets/logo/token-logo.png'
import { ReactComponent as VerifiedIcon } from '../../../../../assets/svg/verified.svg'
import { ReactComponent as AlertIcon } from '../../../../../assets/svg/alert.svg'
import { ReactComponent as ForkIcon } from '../../../../../assets/svg/git-fork.svg'

export interface IActivityIcon {
  [key: string]: any
}

export default function BaseActivity({ historyItem, collection, children, tokenName, chainId }: IActivityDetail) {
  const { action, timestamp, transactionHash, tokenId, account, opponent, saleToken, price } = historyItem
  const tokenLink = `${NFTURLItems.NFT_DETAIL}/${collection.tokenAddress}/${tokenId}`

  const dateTime = new Date(parseInt(timestamp) * 1000)
  const userAccount = getWalletAddress(account)
  const userOpponent = getWalletAddress(opponent)
  const yts = chainId !== undefined ? YTS[chainId] : YTS[ChainId.AVALANCHE]
  const saleTokenItem = useGetSaleTokenItem(saleToken)
  const NFTTokenPrice: string = useGetNFTPrice(price, yts, true)
  const tokenPrice = (
    <span className="activity-token-price">
      {NFTTokenPrice} {<NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />}
    </span>
  )

  const ActivityIcon: IActivityIcon = {
    Listed: <PriceTags className="listed" title="Listed" />,
    Buy: <img src={YTSLogo} alt="Purchased" title="Purchased" />,
    Sold: <img src={YTSLogo} alt="Sold" title="Sold" />,
    Removed: <Removed className="removed" title="Removed" />
  }

  const activity = ActivityIcon[action]

  function getDescription() {
    let message = <span></span>

    const userAccountLink = (
      <NavLink className="account-address" to={`/profile/${account}?tab=on-sale`}>
        {userAccount}
      </NavLink>
    )
    const userOpponentLink = (
      <NavLink className="account-address" to={`/profile/${opponent}?tab=on-sale`}>
        {userOpponent}
      </NavLink>
    )

    if (action === 'Listed') {
      message = (
        <span className="description-text">
          Listed by {userAccountLink} for {tokenPrice}
        </span>
      )
    } else if (action === 'Buy') {
      message = (
        <span className="description-text">
          Purchased by {userAccountLink} for {tokenPrice} from {userOpponentLink}
        </span>
      )
    } else if (action === 'Sold') {
      message = (
        <span className="description-text">
          Purchased by {userOpponentLink} for {tokenPrice} from {userAccountLink}
        </span>
      )
    } else if (action === 'Removed') {
      message = <span className="description-text">Removed by {userAccountLink}</span>
    }

    return message
  }

  return (
    <NFTHistoryItemWrapper>
      <div className="nft-history-item-image">
        <NavLink className="activty-link" to={tokenLink}>
          {children}
          <div className="nft-history-item-action">{activity}</div>
        </NavLink>
      </div>
      <div className="nft-history-item-meta">
        {collection.tokenAddress !== '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d' && (
          <NavLink
            to={`/collection/${collection.tokenAddress}`}
            className="nft-history-item-verified"
            title={`${collection.name} Verified Collection`}
          >
            {collection.forkProject && (
              <ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
            )}
            {collection.oldProject && (
              <AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
            )}
            <VerifiedIcon width="1rem" /> {collection.name}
          </NavLink>
        )}
        <div className="nft-history-item-title">{tokenName}</div>
        <div className="nft-history-item-description">{getDescription()}</div>
        <div className="nft-history-item-bottom">
          <div className="nft-history-item-timestamp">
            {dateTime.toLocaleDateString()} {dateTime.toLocaleTimeString()}
          </div>
          <div className="nft-history-item-hash">
            {chainId && transactionHash && (
              <ExternalLink href={getEtherscanLink(chainId, transactionHash, 'transaction')}>
                <TYPE.subHeader>View transaction on the SnowTrace</TYPE.subHeader>
              </ExternalLink>
            )}
          </div>
        </div>
      </div>
    </NFTHistoryItemWrapper>
  )
}
